import { useState, useEffect } from "react";
import { getDmPoDetails, saveDmPoDetails } from "../api/api";

export function useStaticKpi() {
    const [overrides, setOverrides] = useState({});
    const [loading, setLoading] = useState(true);

    // On mount — load from PHP (which reads the JSON file)
    useEffect(() => {
        getDmPoDetails()
            .then(res => {
                console.log("Loaded KPI overrides:", res);
                setOverrides(res.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    // Save — POST to PHP, which writes into the JSON file
    const saveOverride = async (key, value) => {
        const updated = {
            ...overrides,
            [key]: value === "" ? null : Number(value),
        };

        try {
            const res = await saveDmPoDetails({ [key]: updated[key] });
            if (res.data) {
                setOverrides(updated); // update UI instantly
            }
        } catch (err) {
            console.error("Failed to save:", err);
        }
    };

    return { overrides, saveOverride, loading };
}
